/**
 * Styled Components - Created by david on 07/02/18.
 */
import styled from 'styled-components'
import { RED } from '../../theme/colors'
import Menu from 'antd/lib/menu'
import Divider from 'antd/lib/divider'
import Icon from 'antd/lib/icon'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  width: 72%;
  justify-content: space-between;
  flex-direction: row;
  transition: all .25s;
`

interface OptionDropdownProps {
  $selected?: boolean
  $bold?: boolean
  index?: number
  $secondary?: boolean
}

export const OptionDropdown = styled(Link)`
  &&& {
    cursor: pointer;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    font: 500 12px var(--font-barlow);
    height: 28px;
    letter-spacing: 1.44px;
    text-transform: uppercase;
    transition: color .25s;
    border-bottom: ${({ $selected }: OptionDropdownProps) => $selected ? `2px solid ${RED}` : 'unset'};
    color: ${({ $bold, $selected }: OptionDropdownProps) => 
      $bold || $selected ? 'white' : 'var(--neutral-border-med)'};

    .ant-menu-submenu-popup & {
      height: 36px;
      color: ${({ $bold, $selected }: OptionDropdownProps) => 
        $bold || $selected ? 'var(--neutral-darkest)' : 'var(--neutral-body)'};
    }

    animation: fade-in-left 0.25s
    ${({ index }: OptionDropdownProps) => index ? `${index * 0.06}s` : '0s'} both;
    @keyframes fade-in-left {
      0% {
        transform: translateX(-7px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 14px;
  cursor: pointer;
`

export const Option = styled.div`
  height: 100%;
`

export const dropStyle = {
  paddingTop: 4,
  width: '100%',
  maxWidth: '336px'
}

export const menuStyle = {
  backgroundColor: 'transparent',
  borderBottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
} as React.CSSProperties

export const NavRow = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: var(--spacing-16);
  padding-right: var(--spacing-32);
  > a {
    flex-shrink: 0;
    white-space: nowrap;
  }

  .ant-menu-submenu-popup .ant-menu-item.nav-sport-item {
    height: auto;
    line-height: 28px;
    margin: 0;

    a {
      color: #5f6062;
      height: auto;
      padding: 8px 0;
    }

    &:hover a,
    &.ant-menu-item-active a {
      color: #1a1a1a;
    }
  }
`

export const StyledMenu = styled(Menu)`
  background-color: transparent;
  border-bottom: 0;
  flex: 1;
  min-width: 0;
  line-height: 28px;
  margin-left: var(--spacing-24);

  .ant-menu-item,
  .ant-menu-submenu {
    padding: 0 var(--spacing-16);
    vertical-align: middle;

    :hover {
      border-bottom: 2px solid transparent;
      a {
        color: var(--neutral-white);
      }
    }
  }

  .ant-menu-submenu {
    .ant-menu-submenu-title {
      color: var(--neutral-white);
      padding: 0;
      &:hover {
        color: var(--neutral-white);
      }
    }
  }
`

export const StyledDivider = styled(Divider)`
  height: 45px;
  background: #b7b7b7;
`

export const ContentOptions = styled.div`
  margin-left: -14px;
  margin-right: -14px;
  .title {
    font-size: 13px;
    text-align: center;
    font-weight: bold;
    font-family: Avenir;
    color: #4e4e4e;
  }
`

export const ContentItem = styled.div`
  font-size: 16px;
  padding: 6px 18px;
  padding-right: 14px;
  font-family: Avenir;
  display: flex;
  align-items: center;
  transition: all .25s;
  &:hover {
    background: whitesmoke;
    border-radius: 5px;
    color: cornflowerblue;
    cursor: pointer;
  }
`

export const ContentIcon = styled.img`
  margin-right: 10px;
  max-width: 38px;
  align-self: flex-start;
  margin-top: 8px;
  margin-left: -2px;
`

export const ContentName = styled.div`
  max-width: 100%;
  width: 100%;
  font-size: 14px;
  font-family: Avenir;
  .subtitle {
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -2px;
    vertical-align: middle;
  }
`

export const DescriptionContent = styled.div`
  font-size: 12px;
  color: #626262;
  font-family: Avenir;
  font-weight: normal;
  line-height: 1.45;
`

export const RightArrow = styled(Icon)`
  font-size: 12px;
  color: #4e7cd0;
  margin-left: 8px;
  border: 1px solid #a7c6ff;
  border-radius: 25px;
  padding: 3px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DropdownList/styledComponents.tsx